module.exports = __webpack_public_path__ + "img/ioniq5-n-25.b15ab7be.png";